import { memo } from 'react';
import { motion } from 'framer-motion';
import type { SectionHeaderProps } from '@/src/types';
import { cn } from '@/src/utils';
import { ANIMATIONS } from '@/src/constants';

function SectionHeader({
  badge,
  title,
  subtitle,
  centered = true,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn(centered && 'text-center', 'max-w-3xl', centered && 'mx-auto', 'mb-16', className)}>
      {badge && (
        <motion.div
          {...ANIMATIONS.fadeInUp}
          className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-xs font-bold tracking-widest uppercase mb-6"
        >
          <span>{badge}</span>
        </motion.div>
      )}

      <motion.h2
        {...ANIMATIONS.fadeInUp}
        transition={{ delay: 0.1 }}
        className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight"
      >
        {title}
      </motion.h2>

      {subtitle && (
        <motion.p
          {...ANIMATIONS.fadeInUp}
          transition={{ delay: 0.2 }}
          className="text-lg text-gray-400 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}

export default memo(SectionHeader);
